"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickAmountsByType = exports.quickAmountsTypeMap = exports.maxAmountsCount = exports.minPercentValue = exports.maxPercentValue = exports.DEFAULT_SETTINGS = exports.COOKIE_USER_SETTINGS_NAME = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const types_1 = require("./types");
exports.COOKIE_USER_SETTINGS_NAME = 'cookie_user_settings_name';
exports.DEFAULT_SETTINGS = {
    liveInitiallyDisplayed: false,
    layoutTheme: betweb_openapi_axios_1.LayoutTheme.Light,
    balanceHidden: false,
    onboardPassed: false,
};
exports.maxPercentValue = 100;
exports.minPercentValue = 1;
exports.maxAmountsCount = 5;
exports.quickAmountsTypeMap = {
    [types_1.QuickAmountsTypesDeprecated.percent]: betweb_openapi_axios_1.QuickAmountsType.BalancePercents,
    [types_1.QuickAmountsTypesDeprecated.sum]: betweb_openapi_axios_1.QuickAmountsType.FixedAmounts,
};
exports.quickAmountsByType = {
    [betweb_openapi_axios_1.QuickAmountsType.BalancePercents]: 'balancePercents',
    [betweb_openapi_axios_1.QuickAmountsType.FixedAmounts]: 'fixedAmounts',
};
//# sourceMappingURL=constants.js.map